<template lang="pug">
  component(:is="component" :section="section")
    .alert Es ist ein Fehler aufgetreten
</template>

<script>
import LazyCategoryProducts from '@/extensions/shop/components/LazyCategoryProducts';
import SimpleCategoryProducts from '@/extensions/shop/components/SimpleCategoryProducts';

export default {
    name: 'CategoryProducts',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        LazyCategoryProducts,
        SimpleCategoryProducts
    },
    computed: {
        component() {
            let display = 'detailed'; // default
            let component = 'div';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'display');
                if (setting && setting.value !== undefined) display = setting.value;
            }

            switch (display) {
                case 'tile':
                case 'card':
                case 'row':
                    component = 'SimpleCategoryProducts';
                    break;

                default:
                case 'matrix':
                case 'preorder':
                case 'detailed':
                    component = 'LazyCategoryProducts';
                    break;
            }

            return component;
        }
    }
};
</script>

<style lang="sass"></style>
